module.exports = __webpack_public_path__ + "img/8.ce465d93.jpg";